const defaultPermissions = {
  view: "view",
  create: "create",
  edit: "edit",
  delete: "delete"
};

export default {
  install(Vue, options) {
    const permissions = { ...defaultPermissions, ...options };
    let actions = undefined;

    function build(user) {
      const features = user.modules?.map(module => module.features).flat();
      actions = {};
      features?.forEach(
        feat =>
          (actions[feat.route.split(".")[0]] = feat.actions.map(
            act => act.type
          ))
      );
    }

    function can(target, route = this.$route) {
      let routeName = typeof route === "string" ? route : route.name;
      if (
        typeof route === "object" &&
        route.meta.gfsAuth &&
        route.query.user_gfs_token
      )
        return true;
      return actions[routeName.split(".")[0]]?.some(
        act => act == permissions[target]
      );
    }

    Vue.can = can;
    Vue.buildCan = build;
    Vue.prototype.$can = can;
  }
};
